var map = {
	"./mid_menu_1_1.png": 31747,
	"./mid_menu_2_1.png": 50846,
	"./mid_menu_2_2.png": 82115,
	"./mid_menu_3_1.png": 35617,
	"./mid_menu_3_2.png": 29584,
	"./mid_menu_3_3.png": 43054,
	"./mid_menu_4_1.png": 72790,
	"./mid_menu_4_2.png": 74182,
	"./mid_menu_4_3.png": 83554,
	"./mid_menu_4_4.png": 34528,
	"./mid_menu_5_1.png": 6687,
	"./mid_menu_5_2.png": 84154,
	"./mid_menu_5_3.png": 87023,
	"./mid_menu_5_4.png": 37953,
	"./mid_menu_5_5.png": 17608
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85166;